import { useDispatch } from 'react-redux';

import { Text } from '../../shared/uiComponents';
import { hours, months, weeks } from './Helpers/constants';
import { DayProperties } from './Helpers/interfaces';
import { sortByTime } from './Helpers/functions';
import Session from './Session';
import { DispatchProperties, useSelector } from '../../redux/store';
import { SoapNotesStatuses } from '../../redux/API/ClientAPIHelpers/dataCollectionProperties';
import { useScreenWidth } from '../../shared/Helpers/hooks';
import { useSwipe } from './hooks/useSwipe';
import { goToNextWeek, goToPreviousWeek } from '../../redux/State/clientSlice/calendarHelperSlice';

const WeekView = () => {
	const dispatch = useDispatch<DispatchProperties>();
	const screenWidth = useScreenWidth();
	const isMobile = screenWidth <= 768;

	const showCompletedSession = useSelector((state) => state.calendarHelper.filterData.showCompleted);
	const showDraftsOnly = useSelector((state) => state.calendarHelper.filterData.showDraftsOnly);

	const days = useSelector((state) => state.calendarHelper.displayedCalendarPageDays);
	const events = useSelector((state) => state.calendar.events);
	const startOfWeek = useSelector((state) => state.calendarHelper.weekView.startOfWeek);
	const endOfWeek = useSelector((state) => state.calendarHelper.weekView.endOfWeek);

	const weekRange = days.slice(startOfWeek, endOfWeek);

	const swipeHandlers = useSwipe({
		onSwipeLeft: () => {
			if (isMobile) {
				dispatch(goToNextWeek());
			}
		},
		onSwipeRight: () => {
			if (isMobile) {
				dispatch(goToPreviousWeek());
			}
		},
	});

	return (
		<div className="weekView" {...(isMobile ? swipeHandlers : {})}>
			<div className="row">
				<div className="rowHeaderHour" />
				{weeks.map((weekDay, index) => (
					<div className="rowHeader" key={weekDay}>
						{isMobile ? (
							<>
								<Text title={weekDay.slice(0, 2)} type="pxs" />
								<Text title={weekRange[index]?.day} type="pxs" fontWeight="medium" />
							</>
						) : (
							<>
								<Text title={`${weekDay.slice(0, 3)},`} type="psm" />
								<Text
									title={`${months[weekRange[index]?.month].slice(0, 3)} ${weekRange[index]?.day}`}
									type="psm"
									fontWeight="medium"
								/>
							</>
						)}
					</div>
				))}
			</div>

			{hours.map((hour, hourIndex) => (
				<div className="row" key={hourIndex}>
					<div className="rowCellHour">
						<Text title={hour} type="psm" fontWeight="medium" />
						<div className="dashedLineHour" />
					</div>
					{weeks.map((_: string, index: number) => {
						const weekDay: DayProperties = days.slice(startOfWeek, endOfWeek)[index] || {
							day: '',
							status: 0,
							month: 0,
						};

						return (
							<div key={index} className="rowCell">
								{events &&
									events.length > 0 &&
									[...events]
										.sort((a, b) => sortByTime({ a, b }))
										.filter((x) =>
											showCompletedSession
												? x.isCompleted && x.reportStatus?.status === SoapNotesStatuses.submitted
												: true,
										)
										.filter((x) => (showDraftsOnly ? x.reportStatus?.status === SoapNotesStatuses.draft : true))
										.filter(
											(x) =>
												new Date(x.startTime).getDate() === weekDay.day &&
												new Date(x.startTime).getMonth() === weekDay.month &&
												new Date(x.startTime).getUTCHours() === hourIndex + 5,
										)
										.map((res) => <Session key={res.id} event={res} />)}
								<div className="dashedLine" />
							</div>
						);
					})}
				</div>
			))}
		</div>
	);
};

export default WeekView;
